import { render } from "./FlatsSearch.vue?vue&type=template&id=dde618ea&scoped=true"
import script from "./FlatsSearch.vue?vue&type=script&lang=js"
export * from "./FlatsSearch.vue?vue&type=script&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"
import "./FlatsSearch.vue?vue&type=style&index=1&id=dde618ea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dde618ea"]])

export default __exports__